import React from 'react';
import { useLocation } from 'react-router-dom';
import './layout.css';

const Footer = () => {
    const location = useLocation();
    const showLegalButton = location.pathname !== "/free-retention-calculator";

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-logo">
                    <img src="/footer_logo.svg" alt="ClientBloom Logo" />
                </div>
                {showLegalButton && (
                    <nav className="footer-nav">
                        <a href="/legal">Legal</a>
                    </nav>
                )}
            </div>
        </footer>
    );
};

export default Footer;